import * as React from "react";
import { forwardRef } from "react";
const SteeringWheelIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m3.782 12.009-.032.727a8.252 8.252 0 0 0 6.745 8.113l-.47-2.96c-.219-1.277-1.032-2.477-2.329-3.324L3.782 12.01zm.869-1.224 3.865 2.524a7.61 7.61 0 0 1 .854.646 2.73 2.73 0 0 1-.094-.714c0-.61.2-1.172.538-1.626a20.54 20.54 0 0 1-1.151-.159l-4.012-.671zm9.543.839c.334.453.532 1.012.532 1.618a2.73 2.73 0 0 1-.092.706 7.62 7.62 0 0 1 .846-.639l3.858-2.519-3.849.656c-.43.073-.861.133-1.294.178zm6.025.382L16.3 14.565c-1.299.848-2.112 2.049-2.33 3.327l-.497 2.963a8.253 8.253 0 0 0 6.779-8.119 8.37 8.37 0 0 0-.032-.731zm-8.235 8.653.506-3.016v-.002a5.931 5.931 0 0 1 .703-1.948 2.725 2.725 0 0 1-2.394-.004c.347.607.588 1.264.705 1.952l.002.008.478 3.009zm7.493-11.414a8.252 8.252 0 0 0-14.953-.003l4.386.733a19 19 0 0 0 6.326-.01l4.241-.723zM2.25 12.735c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.365-9.75-9.75zm9.75-.72a1.225 1.225 0 1 0 0 2.45 1.225 1.225 0 0 0 0-2.45z"
}));
const ForwardRef = forwardRef(SteeringWheelIcon);
export default ForwardRef;